
import React, { useMemo } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { clusterApiUrl } from '@solana/web3.js';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ConservationPage from './pages/Conservation';
import RoarMap from './pages/RoarMap';
import GalleryPage from './pages/Gallery';
import Games from './pages/Games';
import BaksoMainGame from './pages/BaksoMainGame';
import Portfolio from './pages/Portfolio';
import SwapPage from './pages/Swap';
import ChatComponent from './components/ChatComponent2';
import TokenPage from './pages/TokenPage';
import AiPage from './pages/AiPage';
import ImageStudio from './components/ImageStudio';
import './App.css';

interface AppContentProps {
  children?: React.ReactNode;
}

const App: React.FC<AppContentProps> = ({ children }) => {
  return (
   
    <Router>
      
      <div className="app">
       
        <div className="content">
          <Routes>
            <Route path="/" element={<HomePage />} />
           
            <Route path="/bakso" element={<TokenPage />} />
            
            <Route path="/gallery" element={<GalleryPage />} />
           
            <Route path="/swap" element={<SwapPage />} />
     
            <Route path="/games" element={<Games />} />
            <Route path="/baksogame" element={<BaksoMainGame />} />
           
      
       
          </Routes>
        </div>
      
      </div>
    
    </Router>

  );
};

export default App;